window.magna ||= {}
magna.scrollIntoView = () => {
  const root = document.getElementById('root')
  if (root.querySelector('.hero') || root.querySelector('.ctr-hero')){
    const options = {
      threshold: 0.8,
    }
    const elements = root.querySelectorAll('scroll')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.setAttribute('data-intersection', `${entry.isIntersecting}`)
      })
    }, options)
    
    const buyObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting || entry.boundingClientRect.top < 200) {
        document.querySelector('.header__bottom')?.classList.add('header__bottom--hide')
      } else {
        document.querySelector('.header__bottom')?.classList.remove('header__bottom--hide')
      }
    })
    
    const heroObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        document.querySelector('.header')?.classList.remove('header--hide')
        document.querySelector('.header__bottom')?.classList.add('header__bottom--hide')
      } else {
        document.querySelector('.header')?.classList.add('header--hide')
        document.querySelector('.header__bottom')?.classList.remove('header__bottom--hide')
      }
    })
    
    // Check for actual target elements, not indicator elements
    const buyContainer = root.querySelector('.buy__container')
    const heroElement = root.querySelector('.hero')
    const ctrProductContainer = root.querySelector('.ctr-product-box__container')
    const ctrHeroElement = root.querySelector('.ctr-hero')
    
    // Observe elements that actually exist
    if (buyContainer) buyObserver.observe(buyContainer)
    if (heroElement) heroObserver.observe(heroElement)
    if (ctrProductContainer) buyObserver.observe(ctrProductContainer)
    if (ctrHeroElement) heroObserver.observe(ctrHeroElement)
    
    elements?.forEach(element => {
      if (element) {
        observer.observe(element)
      }
    })
  } 
}
subscribe(Event.domready, magna.scrollIntoView)